module.exports = __webpack_public_path__ + "static/img/500.7539ff32.svg";